/* eslint-disable no-undef */
import { RealNameAuth2 } from './components/realNameAuth2'

const ui = {
  RealNameAuth2
}

export default ui
